import { interpolate } from "flubber";
import React, { RefObject } from "react";
import { Animated, Easing, Platform, StyleProp, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
/***/

/**
 *
 *  /$$$$$$                               /$$$$$$$  /$$
 * |_  $$_/                              | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$       | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$      | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$      | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$      | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  __  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |$$| |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 */

/*
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="state=down">
 * <path id="Color" fill-rule="evenodd" clip-rule="evenodd" d="M8 5.68292L14.3492 0.240743C14.7685 -0.118679 15.3998 -0.070117 15.7593 0.349209C16.1187 0.768535 16.0701 1.39983 15.6508 1.75926L8.65079 7.75926C8.2763 8.08025 7.7237 8.08025 7.34921 7.75926L0.349211 1.75926C-0.0701143 1.39983 -0.118676 0.768535 0.240746 0.349209C0.600168 -0.070117 1.23147 -0.118679 1.65079 0.240743L8 5.68292Z" fill="#2D3142"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="state=up">
 * <path id="Color" fill-rule="evenodd" clip-rule="evenodd" d="M8.00001 2.31708L1.6508 7.75926C1.23148 8.11868 0.600178 8.07012 0.240756 7.65079C-0.118666 7.23147 -0.0701046 6.60017 0.349221 6.24074L7.34922 0.240743C7.72371 -0.0802478 8.27631 -0.0802478 8.6508 0.240743L15.6508 6.24074C16.0701 6.60017 16.1187 7.23147 15.7593 7.65079C15.3998 8.07012 14.7685 8.11868 14.3492 7.75926L8.00001 2.31708Z" fill="#2D3142"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"state=down": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			},
 * 			"state=up": {
 * 				"type": "ease",
 * 				"duration": 500,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 2
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: StyleProp<ViewStyle>;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: unknown;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  state?: "down" | "up";
  onAnimationComplete?: () => void;
};
/***/

/** Morphing Types */

type tMorphRef = Animated.WithAnimatedValue<React.Ref<React.Component<unknown, unknown, unknown>>> &
  React.Ref<React.Component<unknown, unknown, unknown>>;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d }: { d: string }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigColord: string | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const DropIcon = (props: {
  style?: StyleProp<ViewStyle>;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: unknown;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  state?: "down" | "up";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const { svgRef, maxSegmentLength = 1, onAnimationComplete = () => 0 } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigColord:
        "M8 5.68292L14.3492 0.240743C14.7685 -0.118679 15.3998 -0.070117 15.7593 0.349209C16.1187 0.768535 16.0701 1.39983 15.6508 1.75926L8.65079 7.75926C8.2763 8.08025 7.7237 8.08025 7.34921 7.75926L0.349211 1.75926C-0.0701143 1.39983 -0.118676 0.768535 0.240746 0.349209C0.600168 -0.070117 1.23147 -0.118679 1.65079 0.240743L8 5.68292Z",
    },
  });
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    state: "down" | "up";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      state: "down",
    },
    1: {
      state: "up",
    },
  };

  function getNextMorphState(): number {
    const { state, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (morphStates[possibleMorphState].state === state) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 1;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) =>
    Number((x - Math.min(bound1, bound2)) / (Math.max(bound1, bound2) - Math.min(bound1, bound2)));
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<{
      morphId: keyof tMorphProps;
      paths: string[];
    }>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      const interpolators: {
        [morphId: string]: {
          initial: string;
          final: string;
          interpolator: (t: number) => string;
        };
      } = {};
      interpolations.forEach(({ morphId, paths }) => {
        const initial = paths[start];
        const final = paths[end];
        const p1 = start > end ? final : initial;
        const p2 = start > end ? initial : final;
        const interpolator = interpolate(p1, p2, {
          maxSegmentLength,
        });
        interpolators[morphId] = {
          initial,
          final,
          interpolator,
        };
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.keys(interpolators).forEach((morphId) => {
          const { final, interpolator } = interpolators[morphId];
          let nextInterpolatedPath: string;

          if (value % 1 === 0) {
            nextInterpolatedPath = final;
          } else {
            nextInterpolatedPath = interpolator(normalize(value, start, end));
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
            } else {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  morphProps.bindInterpolation = useGenerateMorphInterpolation(
    [
      {
        morphId: "morphConfigColord",
        paths: [
          "M8 5.68292L14.3492 0.240743C14.7685 -0.118679 15.3998 -0.070117 15.7593 0.349209C16.1187 0.768535 16.0701 1.39983 15.6508 1.75926L8.65079 7.75926C8.2763 8.08025 7.7237 8.08025 7.34921 7.75926L0.349211 1.75926C-0.0701143 1.39983 -0.118676 0.768535 0.240746 0.349209C0.600168 -0.070117 1.23147 -0.118679 1.65079 0.240743L8 5.68292Z",
          "M8.00001 2.31708L1.6508 7.75926C1.23148 8.11868 0.600178 8.07012 0.240756 7.65079C-0.118666 7.23147 -0.0701046 6.60017 0.349221 6.24074L7.34922 0.240743C7.72371 -0.0802478 8.27631 -0.0802478 8.6508 0.240743L15.6508 6.24074C16.0701 6.60017 16.1187 7.23147 15.7593 7.65079C15.3998 8.07012 14.7685 8.11868 14.3492 7.75926L8.00001 2.31708Z",
        ],
      },
    ],
    startValue,
    endValue,
  );

  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 200,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 200,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 16 8" fill="none" id="svg_root" ref={svgRef as RefObject<unknown>} {...props}>
      <G id="state_3Ddown">
        <Path
          id="Color"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 5.68292L14.3492 0.240743C14.7685 -0.118679 15.3998 -0.070117 15.7593 0.349209C16.1187 0.768535 16.0701 1.39983 15.6508 1.75926L8.65079 7.75926C8.2763 8.08025 7.7237 8.08025 7.34921 7.75926L0.349211 1.75926C-0.0701143 1.39983 -0.118676 0.768535 0.240746 0.349209C0.600168 -0.070117 1.23147 -0.118679 1.65079 0.240743L8 5.68292Z"
          fill="#2D3142"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
        />
      </G>
    </Svg>
  );
};
/***/

export default DropIcon;
